var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, query } from 'lit/decorators.js';
let ExEditorToolbarFoldElement = class ExEditorToolbarFoldElement extends LitElement {
    handleClickPopContent(e) {
        if (e.defaultPrevented) {
            return;
        }
        this.button.closeDropdown();
    }
    render() {
        return html `
      <exeditor-toolbar-button class="btn">
        <slot></slot>
        <div
          slot="pop-content"
          class="dropdown"
          @click=${this.handleClickPopContent}
        >
          <slot name="item"></slot>
        </div>
      </exeditor-toolbar-button>
    `;
    }
};
ExEditorToolbarFoldElement.styles = [
    css `
      :host {
        display: inline-block;
      }
      .btn {
        display: block;
      }
      .dropdown {
        display: flex;
        flex-direction: column;
      }
    `,
];
__decorate([
    query('exeditor-toolbar-button')
], ExEditorToolbarFoldElement.prototype, "button", void 0);
ExEditorToolbarFoldElement = __decorate([
    customElement('exeditor-toolbar-fold')
], ExEditorToolbarFoldElement);
export { ExEditorToolbarFoldElement };
//# sourceMappingURL=toolbar-fold.js.map